import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/view/Layout";
Vue.use(VueRouter)
const routes = [
	{
		path: '/',
		name: 'layout',
		component: Layout,
		children: [
			{
				path: 'hbzyglList',
				name: 'hbzyglList',
				component: () => import('@/view/htPage/HbzyglList'),
			},
			{
				path: 'dlsglList',
				name: 'dlsglList',
				component: () => import('@/view/htPage/DlsglList'),
			},
			{
				path: 'dlsCz',
				name: 'dlsCz',
				component: () => import('@/view/htPage/DlsCz'),
			},
			{
				path: 'dlsCzjlList',
				name: 'dlsCzjlList',
				component: () => import('@/view/htPage/DlsCzjlList'),
			},
			{
				path: 'dlsTjf',
				name: 'dlsTjf',
				component: () => import('@/view/htPage/DlsTjf'),
			},
			{
				path: 'dlsTjfjlList',
				name: 'dlsTjfjlList',
				component: () => import('@/view/htPage/DlsTjfjlList'),
			},
			{
				path: 'dlsjgglList',
				name: 'dlsjgglList',
				component: () => import('@/view/htPage/dlsjgPage/DlsjgglList'),
			},
			{
				path: 'dlsjgCz',
				name: 'dlsjgCz',
				component: () => import('@/view/htPage/dlsjgPage/DlsjgCz'),
			},
			{
				path: 'dlsjgCzjlList',
				name: 'dlsjgCzjlList',
				component: () => import('@/view/htPage/dlsjgPage/DlsjgCzjlList'),
			},
			{
				path: 'dlsjgTjf',
				name: 'dlsjgTjf',
				component: () => import('@/view/htPage/dlsjgPage/DlsjgTjf'),
			},
			{
				path: 'dlsjgTjfjlList',
				name: 'dlsjgTjfjlList',
				component: () => import('@/view/htPage/dlsjgPage/DlsjgTjfjlList'),
			},
			{
				path: 'jgShareConfig',
				name: 'jgShareConfig',
				component: () => import('@/view/htPage/JgShareConfig'),
			},
			{	// 基础设置
				path: 'jcsz',
				name: 'jcsz',
				meta: {
					routerName: '基础设置',
				},
				component: () => import('@/view/htPage/Jcsz')
			},
			{	// app每日任务设置
				path: 'mrrwsz',
				name: 'mrrwsz',
				meta: {
					routerName: 'app每日任务设置',
				},
				component: () => import('@/view/htPage/Mrrwsz')
			},
			{	// 用户管理
				path: 'yhgl',
				name: 'yhgl',
				meta: {
					routerName: '用户管理',
				},
				component: () => import('@/view/htPage/Yhgl')
			},
			{
				path: 'dictList',
				name: 'dictList',
				component: () => import ('@/view/sys/DictionaryList'),
				meta: {pageLevel: 1}
			},
			{
				path: 'confList',
				name: 'confList',
				component: () => import ('@/view/sys/SysConfigList'),
				meta: {pageLevel: 1}
			},
			{
				path: 'tzList',
				name: 'tzList',
				component: () => import ('@/view/sys/SysTzList'),
				meta: {pageLevel: 1}
			},
			{
				path: 'menuList',
				name: 'menuList',
				component: () => import ('@/view/sys/SysMenuList'),
				meta: {pageLevel: 1}
			},
			{
				path: 'roleList',
				name: 'roleList',
				component: () => import ('@/view/sys/SysRoleList'),
				meta: {pageLevel: 1}
			},
			{
				path: 'tzListUser',
				name: 'tzListUser',
				component: () => import ('@/view/sys/TzList'),
				meta: {pageLevel: 1}
			},
			{
				path: '/tzDetail',
				name: 'tzDetail',
				component: () => import ('@/view/sys/TzDetail'),
				meta: {pageLevel: 2}
			},
			{
				path: 'bjglList',
				name: 'bjglList',
				component: () => import('@/view/htPage/BjglList'),
			},
			{
				path: 'studentList',
				name: 'studentList',
				component: () => import('@/view/htPage/StudentList'),
			},
			{
				path: 'jsglList',
				name: 'jsglList',
				component: () => import('@/view/htPage/JsglList.vue'),
			},
			{
				path: 'xsbmPage',
				name: 'xsbmPage',
				component: () => import('@/view/htPage/XsbmPage.vue'),
			},
			{
				path: 'bmjl',
				name: 'bmjl',
				component: () => import('@/view/htPage/Bmjl.vue'),
			},
			{
				path: 'khyjl',
				name: 'khyjl',
				component: () => import('@/view/htPage/Khyjl.vue'),
			},
			{
				path: 'thyjl',
				name: 'thyjl',
				component: () => import('@/view/htPage/Thyjl.vue'),
			},
			{
				path: 'kthy',
				name: 'kthy',
				component: () => import('@/view/htPage/kthy.vue'),
			},
			{
				path: 'cityList',
				name: 'cityList',
				component: () => import ('@/view/htPage/CityList'),
			},
			{
				path: 'jfxhjl',
				name: 'jfxhjl',
				component: () => import ('@/view/htPage/Jfxhjl'),
			},
			{
				path: 'ywList',
				name: 'ywList',
				component: () => import ('@/view/htPage/YwList.vue'),
			},
		]
	},
	{
		path: '/pcLogin',
		name: 'Login',
		component: () =>import ('@/view/Login.vue'),
	},
];

const router = new VueRouter({
    mode: 'hash',
    //base: process.env.BASE_URL,
    routes
})


const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router